var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.address },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.address,
              expression: "value.address",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-address",
            id: _vm.name + "-client_home_address",
            placeholder: "Address",
          },
          domProps: { value: _vm.value.address },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "address", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_home_address" },
          },
          [_vm._v(_vm._s(_vm.$t("address", "form_shipment")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.address_more },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.address_more,
              expression: "value.address_more",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-address_more",
            id: _vm.name + "-client_home_address_more",
            placeholder: "Ulica",
          },
          domProps: { value: _vm.value.address_more },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "address_more", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_home_address_more" },
          },
          [_vm._v(_vm._s(_vm.$t("address_more", "form_shipment")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-lg-6 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.postal_code },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.postal_code,
              expression: "value.postal_code",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-postal_code",
            id: _vm.name + "-client_home_street_part_2",
            placeholder: "Ulica (Uzupełnienie)",
          },
          domProps: { value: _vm.value.postal_code },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "postal_code", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_home_street_part_2" },
          },
          [_vm._v(_vm._s(_vm.$t("post_code", "form_shipment")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 col-lg-6 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.city },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.city,
              expression: "value.city",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-city",
            id: _vm.name + "-client_city",
            placeholder: "City",
          },
          domProps: { value: _vm.value.city },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "city", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_city" },
          },
          [_vm._v(_vm._s(_vm.$t("city", "form_shipment")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.country },
      },
      [
        _c("v-select", {
          attrs: { options: _vm.countriesList },
          model: {
            value: _vm.selected_country,
            callback: function ($$v) {
              _vm.selected_country = $$v
            },
            expression: "selected_country",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            class: { "form-group__animated__label--active": _vm.changeLabel },
            attrs: { for: _vm.name + "-client_country" },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("country", "form_shipment")) +
                "\n            "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.phone_number },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.phone_number,
              expression: "value.phone_number",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: _vm.name + "-client_phone",
            id: _vm.name + "-client_phone",
            placeholder: "Telefon",
          },
          domProps: { value: _vm.value.phone_number },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "phone_number", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-client_phone" },
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.$t("phone", "form_shipment"))
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.pathname === "/checkout/"
      ? _c("div", { staticClass: "col-12 form-group form-group__animated" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value.order_notes,
                expression: "value.order_notes",
              },
            ],
            staticClass:
              "form-group__input form-group__input--paddings-classic form-group__animated__input",
            attrs: {
              type: "text",
              name: _vm.name + "-order_notes",
              id: _vm.name + "-order_notes",
              placeholder: "Uwagi do zamówienia",
            },
            domProps: { value: _vm.value.order_notes },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.value, "order_notes", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-group__animated__label",
              attrs: { for: _vm.name + "-order_notes" },
            },
            [_vm._v("\n            Uwagi do zamówienia\n          ")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }